import { render, staticRenderFns } from "./Extracts.vue?vue&type=template&id=0d1df512&"
import script from "./Extracts.vue?vue&type=script&lang=js&"
export * from "./Extracts.vue?vue&type=script&lang=js&"
import style0 from "./Extracts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports